<!-- ========== Left Sidebar Start ========== -->


<div class="vertical-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <a [routerLink]="['/']" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/logo-light.png" alt="" class="imgClass">
      </span>
      <span class="logo-lg">
        <img src="assets/images/logo-dark.png" alt="" height="100%" width="75%">
      </span>
    </a>

    <a [routerLink]="['/']" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/logo-sm.png" alt="" height="100%" width="75%">
      </span>
      <span class="logo-lg">

        <img src="assets/images/logo-light.png" alt="" height="75%" width="100%" class="logo logo-light">
      </span>
    </a>
  </div>
  <!-- <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
    (click)="toggleMobileMenu($event)">
    <i class="fa fa-fw fa-bars"></i>
  </button> -->

  <ngx-simplebar class="sidebar-menu-scroll" #componentRef *ngIf="!isCondensed">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ngx-simplebar>

  <ngx-simplebar class="sidebar-menu-scroll" #componentRef *ngIf="isCondensed">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ngx-simplebar>

</div>


<ng-template #contentTemplate>
  <div class="background-image" style="background-image: url('assets/images/oiletoil2.png');">
    <!--- Sidemenu -->
    <div id="sidebar-menu" style="color: black;">
      <!-- Left Menu Start -->
      <ul class="metismenu list-unstyled" id="side-menu" #sideMenu style="color: black;">
        <ng-container *ngFor="let item of menuItems" style="color: black;">
          <li class="menu-title" *ngIf="item.isTitle">{{ item.label}}</li>
          <!-- Layouts menu -->
          <li *ngIf="item.isLayout">
            <a href="javascript: void(0);" class="has-arrow" style="color: black;">
              <i class="uil-window-section"></i>
              <span style="color: black;"> {{'MENUITEMS.LAYOUTS.TEXT'}}</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
              <li><a (click)="changeLayout('horizontal')" href="javascript: void(0);"> {{
                  'MENUITEMS.LAYOUTS.LIST.HORIZONTAL'}} </a></li>
              <li><a (click)="darkSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.DARKSIDEBAR' }} </a>
              </li>
              <li><a (click)="compactSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.COMPACTSIDEBAR'}}
                </a></li>
              <li><a (click)="iconSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.ICONSIDEBAR'}} </a>
              </li>
              <li><a (click)="boxedLayout()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.BOXEDWITH'}} </a>
              </li>
              <li><a (click)="coloredSidebar()" href="javascript: void(0);">{{ 'MENUITEMS.LAYOUTS.LIST.COLOREDSIDEBAR'}}
                </a></li>
            </ul>
          </li>
          <!-- end Layout menu -->

          <li *ngIf="!item.isTitle && !item.isLayout">
            <a *ngIf="hasItems(item)" class="is-parent"
              [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
              <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
              <span> {{ item.label }}</span>
              <span class="badge rounded-pill bg-{{item.badge.variant}} float-end" *ngIf="item.badge">{{item.badge.text }}</span>
            </a>
            <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref" routerLinkActive="active"
              [ngClass]="{'active': isActive(item.link)}">
              <i class="bx {{ item.icon }}" *ngIf="item.icon"></i>
              <span>{{ item.label }}</span>
            </a>
            <ul *ngIf="hasItems(item)" class="sub-menu" aria-expanded="false">
              <li *ngFor="let subitem of item.subItems">
                <div>
                  <!-- et ses childs -->
                  <a [routerLink]="subitem.link" *ngIf="!hasItems(subitem)" class="side-nav-link-ref"
                    [attr.data-parent]="subitem.parentId" routerLinkActive="active" >
                    <i class="bx {{ subitem.icon }}" *ngIf="subitem.icon"></i> {{ subitem.label}}
                  </a>
                  <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref " [attr.data-parent]="subitem.parentId"
                    [routerLink]="subSubitem.link" routerLinkActive="active">
                    {{ subitem.label}}
                  </a>
                  <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                    <li *ngFor="let subSubitem of subitem.subItems">
                      <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                        routerLinkActive="active" class="side-nav-link-ref">
                        {{ subSubitem.label }}
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</ng-template>
<!-- Sidebar -->


<!-- Left Sidebar End -->